export const isCousin = (numero) => numero % 2 === 0;
